import React, { useRef } from 'react';
import styled from 'styled-components';
import { SectionConditional } from 'components';
import { theme, toRem } from 'design';
import { Button } from '../Button';
import { Text } from '../Typography';

interface IFileUploadDropZoneProps {
  onUpload: (file: any) => void;
  accept?: string;
  onClick?: () => void;
  instructions?: string | React.ReactNode;
  label?: string;
  size?: 'large' | 'small';
  appearance?: 'primary' | 'secondary';
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
}

const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${theme.color.white};
  border: ${toRem(2)} dashed ${theme.color.neutral[200]};
  border-radius: ${toRem(theme.borderRadius.medium)};
  padding: ${toRem(72)} ${toRem(92)};
  position: relative;

  input {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  p {
    font-size: ${toRem(16)};
  }
`;

const FileUploadDropZone: React.FC<IFileUploadDropZoneProps> = ({ onUpload, accept, onClick, label = 'Browse Files', instructions, appearance = 'primary', size = 'large', disabled, isLoading, className }) => {
  const hiddenFileInput = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    onClick?.();
    if (hiddenFileInput && hiddenFileInput.current) {
      hiddenFileInput.current.value = '';
      hiddenFileInput.current.click();
    }
  };

  const handleChange = (event: any) => {
    event.preventDefault();
    const fileUploaded = event.target.files[0];
    onUpload(fileUploaded);
    if (hiddenFileInput.current) hiddenFileInput.current.value = '';
  };

  return (
    <Container data-cy="file-upload-drop-zone">
      <input type="file" id="fileInput" ref={hiddenFileInput} onChange={handleChange} accept={accept} title="" />
      {instructions || <Text fontWeight="semibold">Drag your CSV file here to start uploading.</Text>}
      <SectionConditional condition="or" width={25} />
      <Button label={label} type="button" appearance={appearance} size={size} disabled={disabled} isLoading={isLoading} onClick={handleClick} className={className} />
    </Container>
  );
};

export default FileUploadDropZone;
